import { render, staticRenderFns } from "./nav.export.vue?vue&type=template&id=35a6060d&scoped=true&lang=pug&"
import script from "./nav.export.vue?vue&type=script&lang=js&"
export * from "./nav.export.vue?vue&type=script&lang=js&"
import style0 from "./nav.export.vue?vue&type=style&index=0&id=35a6060d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a6060d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('35a6060d', component.options)
    } else {
      api.reload('35a6060d', component.options)
    }
    module.hot.accept("./nav.export.vue?vue&type=template&id=35a6060d&scoped=true&lang=pug&", function () {
      api.rerender('35a6060d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project_editor/component/nav.export.vue"
export default component.exports